import { memo } from 'react';

function TrashIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.9445 4.11111L12.2699 13.5553C12.2118 14.3693 11.5344 15 10.7183 15H4.28179C3.46569 15 2.78834 14.3693 2.73019 13.5553L2.05561 4.11111M5.9445 7.22222V11.8889M9.05561 7.22222V11.8889M9.83339 4.11111V1.77778C9.83339 1.34822 9.48516 1 9.05561 1H5.9445C5.51494 1 5.16672 1.34822 5.16672 1.77778V4.11111M1.27783 4.11111H13.7223"
        stroke="currentColor"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default memo(TrashIcon);
